
import commaNumber from 'comma-number'
import analytics from '@/helpers/analytics'
import { itemDisplayAmountAndSymbol } from '@/helpers/currencyDisplay'
import criteo from '@/helpers/criteo'
import fireConversionEvents from '@/helpers/fireConversionEvents'
import fireTaboolaEvents from '@/helpers/fireTaboolaEvents'

export default {
  props: {
    options: {
      type: Object,
      default: null
    },
    item: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      maxShowPartners: 8,
      maxShowItems: 10,
      minPartnerItems: 2,
      minPercentGap: 0.15,
      maxPercentGap: 0.03,
      minPartnersGap: 3,
      maxClickout: 5,
      clickoutCount: {},
      expiredPartners: [],
      mainPartnerCard: null,
      partners: []
    }
  },
  computed: {
    isPendingApproval() {
      return this.mainPartnerCard && this.mainPartnerCard.tier > 1
    },
    specialItemClass() {
      return (this.options && this.options.specialType) ? this.options.specialType : ''
    },
    isSponsored() {
      return this.options && this.options.specialType && (this.options.specialType === 'sponsored')
    },
    isVerified() {
      return this.options && this.options.specialType && (this.options.specialType === 'verified')
    },
    deeplinks() {
      return this.$store.state.deeplinks
    },
    maxClickoutReached() {
      return Object.values(this.clickoutCount).some(count => count >= this.maxClickout)
    },
    expiredPartnerCount () {
      return this.expiredPartners.length
    },
    mainPriceUi () {
      if (!this.mainPartnerCard) return { amount: 0, symbol: '' }
      return itemDisplayAmountAndSymbol(
        this.mainPartnerCard,
        this.$store.state,
        this.item
      )
    },
    minPriceFormatted() {
      if (!this.mainPartnerCard) return ''
      return commaNumber(Math.round(this.mainPriceUi.amount))
    },
    shouldShowPartnerName() {
      if (this.item.showPartnerName !== undefined) {
        return this.item.showPartnerName == 1
      }
      return this.item.cpc > 0
    },
    shouldShowPartnerList() {
      if (this.options && this.options.hideDropdown !== undefined) {
        return false
      }
      return this.item.partners && this.shouldShowPartnerName
    },
    parsedItems () {
      const partners = this.item.partners.slice(0, this.maxShowPartners)

      const parsedPartners = partners.map((partnerItem) => {
        return { ...partnerItem, component: 'DropdownPartnerItem' }
      })

      const maxShowDiff = this.maxShowItems - parsedPartners.length

      const parsedCompare = this.$store.state.compareItems.slice(0, maxShowDiff).map((compareItem) => {
        return { ...compareItem, component: 'DropdownCompareItem' }
      })

      return parsedPartners.length > this.minPartnerItems ? [...parsedPartners] : [...parsedPartners, ...parsedCompare]
    },
    displaySymbol () {
      return this.mainPriceUi.symbol
    }
  },
  watch: {
    parsedItems: {
      immediate: true,
      deep: true,
      handler (newVal) {
        this.partners = newVal
        this.reOrderParners()
      }
    },

    maxClickoutReached: {
      immediate: true,
      deep: true,
      handler () {
        this.reOrderParners()
      }
    }

  },
  beforeMount () {
  },
  methods: {
    setMainPartnerCard () {
      if (!this.partners || this.partners.length === 0) {
        this.mainPartnerCard = this.item
        return
      }
      this.mainPartnerCard = this.partners.shift()
      if (this.mainPartnerCard == null) {
        this.mainPartnerCard = this.item
      }
    },
    reOrderParners () {
      if (this.partners.length === 0) {
        this.setMainPartnerCard()
        return
      }
      let partners = [...this.parsedItems]

      if (this.maxClickoutReached) {
        /// Move expired partners to the end of the array
        const expiredPartners = this.getExpiredPartners(partners)
        partners = partners.filter(
          partnerItem => !expiredPartners.some(exp => exp.partner === partnerItem.partner)
        )
        partners.push(...expiredPartners) // Add expired partners at the end
      }

      this.partners = partners
      this.setMainPartnerCard()
    },
    addExpiredPartner () {
      this.expiredPartners = Object.keys(this.clickoutCount).filter(
        partner => this.clickoutCount[partner] >= this.maxClickout
      )
    },
    getExpiredPartners (partners) {
      this.addExpiredPartner()
      const expiredPartners = partners.filter((partnerItem) => {
        if (this.expiredPartners.includes(partnerItem.partner)) {
          return true // Remove from the current position
        }
        return false
      })

      return expiredPartners
    },
    handleCardClick() {
      this.shouldShowPartnerName ? this.openPartnerDeeplinkUrl() : this.openCompareModal()
    },
    clickHandler() {
      return this.openPartnerDeeplinkUrl()
    },
    clickPhoneQuote() {
      analytics.track('meta-unit-phone-click', this)
      window.top.location = `tel:${this.item.phoneQuote.number}`

      try {
        // Taboola event
        fireTaboolaEvents('phone-clickout', this)
      } catch (error) {
        console.info('Error firing Taboola event', error)
      }
    },
    partnerClick (item) {
      if (item === undefined) {
        item = this.item
      }

      if (item.cpc === undefined || item.cpc <= 0) {
        return
      }

      // Increment clickout count per partner
      if (this.clickoutCount[item.partner]) {
        this.clickoutCount[item.partner]++
      } else {
        this.$set(this.clickoutCount, item.partner, 1)
      }

      const partnerCpc = Number(item.cpc).toFixed(2)
      const currency = 'USD'

      fireConversionEvents(this, {
        value: partnerCpc,
        currency: currency,
        bing: {
          eventName: "OTAclickout",
        },
      });

      // Criteo product tag
      this.pushCriteoParams()

      // Adara event
      this.fireAdaraEvent(this.item)

      try {
        // Taboola event
        fireTaboolaEvents('ota-clickout', this)
      } catch (error) {
        console.info('Error firing Taboola event', error)
      }
    },
    openPartnerDeeplinkUrl() {
      // Skip triggering the event for fallback partner (cpc = 0)
      if (this.mainPartnerCard.cpc > 0) {
        this.partnerClick(this.mainPartnerCard)
      }
      analytics.track('pricelink-click', this)
      console.info('Open partner deeplink URL')
      window.newTab = window.open(this.mainPartnerCard.partnerDeeplinkUrl, '_blank')
    },
    openCompareModal() {
      if (this.$store.state.isCompareToAdsModalLoaded) {
        this.$store.commit('setInlineAdDeeplink', this.item.partnerDeeplinkUrl)
        this.$emit('openCompareModal')
        return
      }

      // Fallback if compare modal is not loaded
      this.openApiDeeplinkUrls()
    },
    openApiDeeplinkUrls () {
      analytics.track('view-deals-click', this)

      try {
        // Taboola event
        fireTaboolaEvents('depplinks-clickout', this)
      } catch (error) {
        console.info('Error firing Taboola event', error)
      }
      console.info('Open API deeplink URLs')
      const deeplinks = this.item.apiDeeplinkUrls
      window.newTab = window.open('', '_blank')

      if (deeplinks[0]) {
        window.newTab.location.href = deeplinks[0].redirect
      }

      if (deeplinks[1]) {
        window.location.href = deeplinks[1].redirect
      }

      if (deeplinks[2] && window.popUnder) {
        window.popUnder.location.href = deeplinks[2].redirect
        window.popUnder.moveTo(0, 0)
        window.popUnder.resizeTo(screen.width, screen.height)
      }
    },
    compareAll (data) {
      this.$emit('compareAll', data)
    },
    pushCriteoParams () {
      const customerId = this.$store.state.entryId
      const currency = this.item.currency ?? 'USD'
      const id = customerId + this.item.uniqueId
      const price = this.item.cpc

      const options = { customerId, currency, price, id }
      criteo.purchaseTag(this.$store, options)
    },
    fireAdaraEvent (item) {
      if (Object.keys(item).length === 0) return

      const flightSearchData = this.$store.state.flightsSearchFormData

      const adaraParams = {
        travelProductType: 'Flight',
        tripType: item.legs.length === 2 ? 'roundtrip' : 'one-way',
        originAirportCode: item.legs[0].from.code,
        originCity: item.legs[0].from.city,
        // originCountry,
        // originState,
        destinationAirportCode: item.legs[1] ? item.legs[1].from.code : item.legs[0].to.code,
        destinationCity: item.legs[1] ? item.legs[1].from.city : item.legs[0].to.city,
        // destinationCountry,
        // destinationState,
        departureDate: item.legs[0].depTime.split('T')[0],
        returnDate: item.legs[1] ? item.legs[1].depTime.split('T')[0] : '',
        numPassenger: flightSearchData.adults + flightSearchData.children,
        numAdults: flightSearchData.adults,
        numChildren: flightSearchData.children,
        ticketClass: item.cabinClass,
        ticketPrice: item.minPrice,
        airlineBrand: item.legs[0].airline.name
      }
      try {
        window.adara('send', {
          pageType: 'Purchase Item',
          siteLanguage: this.$store.state.language,
          siteCountry: this.$store.state.country,
          ...adaraParams
        })
      } catch (e) {
        console.info('Error firing Adara event')
      }
    }
  }
}
